import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ConsentForm from "./ConsentForm";
import ConsentWhitespace from "../pageswhitespace/ConsentWhitespace";
import FullScreenLoader from "@/components/FullScreenLoader";


const ConsentRouting = () => {
  const { enc_id } = useParams<{ enc_id: string }>();
  const [isWhitespace, setIsWhitespace] = useState<boolean | null>(null);

  useEffect(() => {
    if (enc_id === 'WHITESPACE') {
      setIsWhitespace(true);
    } else {
      setIsWhitespace(false);
    }
  }, [enc_id]);

  if (isWhitespace === null) {
    return <FullScreenLoader loading={true} />;
  }

  if (isWhitespace) {
    return <ConsentWhitespace />;
  }

  return <ConsentForm />;
};

export default ConsentRouting;
